import React from 'react';
import cn from 'clsx';

import { ChevronRightRegularIcon } from '../../shared/icons/icons';

import styles from './summary-bar.scss';

interface SummaryBarProps {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}

function SummaryBar(props: SummaryBarProps) {
  const { children, className, onClick } = props;

  return (
    <button className={cn(styles['container'], className)} onClick={onClick}>
      <div className={styles['label']}>{children}</div>
      <ChevronRightRegularIcon className={styles['icon']} />
    </button>
  );
}

export default SummaryBar;
